// Load jQuery from NPM
import $ from 'jquery';

window.jQuery = $;
window.$ = $;

import 'bootstrap';
import 'lodash';
import bsCustomFileInput from 'bs-custom-file-input';

(function(){
	'use strict';

	// Global variables
	var squiz = {
		'fn': {},
		'vars': {
			'animSpeed' : 400,
			'navIsAnimating' : false,
		}
	};

	/**
	* ===================================================
	* Responsive helpers
	* ===================================================
	*/
	var ww = $(window).width();

	var breakpoint = {
		'lg': 1200,
		'md': 992,
		'sm': 768,
		'xs': 544
	};

	$('.main table').each(function() {
		var $table = $(this);
		$table.wrap('<div class="table-responsive-sm table-responsive-md table-responsive-lg"></div>');
	});



	/**
	* ===================================================
	* Helpers
	* ===================================================
	*/
	squiz.fn.smpScrollTopBtn = function(selector, offset){

		$(selector).click(function(){

			$('html,body').animate({
				scrollTop: offset
			}, squiz.vars.animSpeed);

			return false;

		});
	}

	squiz.fn.smpClearNavItemState = function(subElementContainer, subElementBtns){

		if(!$('.smp-header__mobile-btn').is(':visible')){
			$(subElementContainer).removeClass('active').attr('aria-expanded','false');
			$(subElementBtns).find('button').removeClass('active');
		}
	}

	squiz.fn.smpToggleBtn = function(selector){

		if(!$(selector).hasClass('active')){
			$(selector).addClass('active');
			return false;
		} else {
			$(selector).removeClass('active');
			return true;
		}

	}

	squiz.fn.smpAnimMenu = function(selector, open){

		if(!open){

			$(selector).slideDown(squiz.vars.animSpeed, function(){
				$(selector).addClass('active');
			});

		} else {

			$(selector).slideUp(squiz.vars.animSpeed, function(){
				$(selector).removeClass('active');
			});
		}
	}

	squiz.fn.smpToggleSubMenu = function(selector, show){

		if(show){
			$(selector).addClass('active');
			$(selector).attr('aria-expanded','true');
		} else {
			$(selector).removeClass('active');
			$(selector).attr('aria-expanded','false');
		}

	}

	// Make squiz variable available to the console for debugging

	window.squiz = squiz;
}());
